import { Component, inject } from '@angular/core'
import { BricksProgressSpinnerComponent } from '@enbw_bricks/ui'
import { LoadingSpinnerService } from './loading-spinner.service'

@Component({
  selector: 'app-loading-spinner',
  imports: [BricksProgressSpinnerComponent],
  templateUrl: './loading-spinner.component.html',
  styleUrl: './loading-spinner.component.scss',
})
export class LoadingSpinnerComponent {
  protected readonly service = inject(LoadingSpinnerService)
}
